/* global _, Toasts, MarketItemTagsViewModel, debug */

$(function () {
    'use strict';

    $(document).on('ready', function () {
        var $marketplaceFilter = $('[data-marketplace-filter]');

        $marketplaceFilter.find('select').on('change', function () {
            $marketplaceFilter.trigger('submit');
        });

        var $marketplaceOrder = $('[data-marketplace-order]');

        $(document).on('click', function (event) {
            if ($(event.target).is('[data-marketplace-order]')) {
                event.preventDefault();
                $marketplaceOrder.parent().toggleClass('marketplace__order-drop_hidden');
            }
            else {
                $marketplaceOrder.parent().addClass('marketplace__order-drop_hidden');
            }
        });
    });
});